import { render, staticRenderFns } from "./AppOptions.vue?vue&type=template&id=aae36f0a"
import script from "./AppOptions.vue?vue&type=script&lang=ts"
export * from "./AppOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports